import React from "react";
import { useApiClient } from "../../../shared/customHooks";
import { useApplicationContext } from "../context/applicationContext";
import { screeningQuestionsForm } from "../../../shared/formObjects/application/screeningQuestionsForm";
import BaseApplicationComponent from "../../../shared/baseComponent/baseWrappers/BaseApplicationComponent";

function ScreeningQuestionsComponent({ disabled, data }: any) {
  const api = useApiClient("ScreeningQuestions");
  const { id } = useApplicationContext();

  return (
    <BaseApplicationComponent
      formBody={screeningQuestionsForm}
      headerLabel="Screening Questions"
      editPath="screeningQuestions"
      apiClient={api}
      disabled={disabled}
      data={data}
      id={id}
    />
  );
}

export default ScreeningQuestionsComponent;
